<template>
    <div class="relative min-h-screen overflow-hidden" :class="{ 'dark': isDark }">

        <!-- Background -->
        <div class="fixed inset-0 bg-gray-50 dark:bg-gradient-to-bl dark:from-[#083C69] dark:to-[#05192A] -z-10"></div>

        <!-- Content -->
        <div class="relative text-gray-800 dark:text-white">
            <slot /> <!-- Page content gets injected here -->
        </div>
        <!-- Toast Container -->
        <toast-container />

        <!-- Confirm Modal Container -->
        <confirm-modal-container />
    </div>
    <!--
    <div class="flex items-center justify-center">
        <nuxt-link class="cursor-pointer text-blue-500 hover:underline" to="/">Splash</nuxt-link>
        <span class="px-2">|</span>
        <nuxt-link class="cursor-pointer text-blue-500 hover:underline" to="/sign-in">Sign In</nuxt-link>
        <span class="px-2">|</span>
        <nuxt-link class="cursor-pointer text-blue-500 hover:underline" to="/sign-up">Sign Up</nuxt-link>
        <span class="px-2">|</span>
        <nuxt-link class="cursor-pointer text-blue-500 hover:underline" to="/app">Dashboard</nuxt-link>
        <span class="px-2">|</span>
        <nuxt-link class="cursor-pointer text-blue-500 hover:underline" to="/password-recovery">Password Recovery</nuxt-link>
        <span class="px-2">|</span>
        <nuxt-link class="cursor-pointer text-blue-500 hover:underline" to="/legal">Legal</nuxt-link>
        <span class="px-2">|</span>
    </div>
    -->
</template>

<script setup lang="ts">

import '@fontsource/inter/400.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import { useUserStore } from "~/stores/userStore";
import ToastContainer from '~/components/utilities/toast-container.vue';
import ConfirmModalContainer from '~/components/modals/confirm-modal.vue';

const userStore = useUserStore();
const isDark = computed(() => userStore.darkMode);

</script>